import React, { useEffect } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigation } from 'hooks/index';
import { Title } from 'components/commons';
import ShareUrl from 'components/share-url';
import { SITE_URL } from 'env';
import { formatMoney, formatCnpj, getLoanApplicationParams } from 'utils/utils';
import arrowRightIcon from 'assets/svg/arrow-right.svg';
import { useGetLoanQuery } from 'generated/graphql';
import './bizon-send--link.styles.scss';


type BoxProps = {
    title?: string,
};

const SendLinKpartner: React.FC <BoxProps> = ({ title = 'enviar este link para o sócio' }): JSX.Element => {
    const loanApplicationId  = getLoanApplicationParams();
    const [whatsappMessage, setWhatsappMessage] = React.useState("Olá, preciso que você entre nesse link e continue com a analise de crédito na BizCapital...");
    const [editMessage, setEditMessage] = React.useState(false);

    const { data } = useGetLoanQuery({
        variables:{
            id:loanApplicationId
        },
        fetchPolicy:"cache-first"
    });

    useEffect(() => {
        if (!data?.loanApplication) {
            return;
        }
        setWhatsappMessage(
            `Olá, somos da BizCapital. Foi feito um pedido no nome de ${data?.loanApplication.borrower.responsibleName} para o CNPJ: ${formatCnpj(data?.loanApplication.borrower.companyDocument)} no valor de R$ ${formatMoney(data?.loanApplication.amountRequested)}, e para finalizar a proposta da empresa precisamos da confirmação do(s) sócio(s).

Após abrir o link será necessário confirmar algumas informações. É rapidinho:

• Validação com um CPF de um sócio presente no quadro societário;
• Fotos do documento de RG ou CNH e selfie do mesmo;
• Preenchimento de questionário;

Segue o link: ${SITE_URL}/pedido/${loanApplicationId}/socio/identificacao`)
    }, [data?.loanApplication]);

    const {
        goToAntiFraudCheckout,
    } = useNavigation();

    return (
        <div className="l-documents-screen grid-container">
            <div className="l-documents-screen__content">
                <Title className="mb-4">
                    {title}
                </Title>

                <p className="body-1 mb-4">
                    Envie o link para seu sócio continuar o processo. Assim que recebermos, você será avisado para continuar.
                </p>

                <div className="l-documents-screen__box bizon-send--link__box">
                    <div className="l-documents-screen__invitation">
                        <h3 className="bold">
                            Escolha a opção de envio:
                        </h3>
                        <ShareUrl
                            url={`${SITE_URL}/pedido/${loanApplicationId}/socio/identificacao`}
                            whatsappMessage={whatsappMessage}
                        />
                        <div className="bizon-send--link__box-text">
                            <InputTextarea
                                rows={3}
                                value={whatsappMessage}
                                disabled={!editMessage}
                                className="link-textare"
                                onChange={(e) => setWhatsappMessage(e.currentTarget.value)}
                            />
                            <button onClick={() => setEditMessage(!editMessage)}>
                                {!editMessage ? 'editar' : 'salvar'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bizon-send--link__footer">
                <div className="text-left align-top button-wrapper">
                    <button
                        className="btn-biz secondary"
                        type="button"
                        onClick={goToAntiFraudCheckout}
                    >
                        <img
                            className="hidden-lg" src={arrowRightIcon}
                        />
                        <span className="hidden-sm">voltar</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SendLinKpartner;
